import React from 'react';
import ActiveFlowRow from './ActiveFlowRow';
import DeletedFlowRow from './DeletedFlowRow';
import type { ColumnWidths } from '../types';

interface FlowRowContentProps {
  flowMeta: any;
  query: any;
  removeFlow: (flowId: string) => void;
  columnWidths: ColumnWidths;
}

const FlowRowContent: React.FC<FlowRowContentProps> = ({
  flowMeta,
  query,
  removeFlow,
  columnWidths,
}) => {
  if (flowMeta?.isDeleted) {
    return (
      <DeletedFlowRow flowMeta={flowMeta} removeFlow={removeFlow} columnWidths={columnWidths} />
    );
  }
  return <ActiveFlowRow flowMeta={flowMeta} query={query} columnWidths={columnWidths} />;
};

export default FlowRowContent;
